import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { isUnauthorized, useMe } from "@/lib/auth";

// Sends the visitor to /login only when the API says the session is invalid.
// If the API cannot be reached the app still opens: MOS is offline-first.
export function RequireAuth({ children }: { children: ReactNode }) {
	const me = useMe();
	const location = useLocation();

	if (me.isPending) {
		return <div className="min-h-dvh" aria-busy="true" />;
	}
	if (isUnauthorized(me.error)) {
		const next = location.pathname + location.search;
		return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
	}
	return children;
}
